<script setup lang="ts">
const { data: page } = await useAsyncData('index', () => queryCollection('content').path('/').first())

useSeoMeta({
  title: page.value.title,
  description: page.value.description,
})
</script>

<template>
  <UPageHero
      :title="page.meta.hero.title"
      :description="page.meta.hero.description"
      orientation="horizontal"
  >
    <template #default>
      <NuxtImg src="/home.jpg"
          class="w-full rounded-md shadow-xl ring-1 ring-gray-300 dark:ring-gray-700"
               alt="Bénévoles de la Croix-Rouge française en train de faire du bénévolat"
      />
    </template>
  </UPageHero>

  <SectionManager :sections="page.meta.sections">
    <template #services-section="{ section }">
      <UPageSection v-bind="section">
        <UPageGrid class="lg:grid-cols-12">
          <UPageCard v-for="(item, index) in section.items"
                        :key="index"
                        v-bind="item" />
        </UPageGrid>
      </UPageSection>
    </template>
  </SectionManager>
</template>
